// extracted by mini-css-extract-plugin
export default {"Container":"home_Container__n+1z6","headingContainer":"home_headingContainer__llJBk","mainHeading":"home_mainHeading__eIyuF","info":"home_info__FPRCa"};